module.exports = __webpack_public_path__ + "fff09f3134317ba9f9f899fda54af5da.png";